import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule} from '@angular/flex-layout';
import {TranslateModule} from '@ngx-translate/core';
import {MatInputModule} from "@angular/material/input";

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        FlexLayoutModule,
        TranslateModule
    ],
})
export class AlertComponent {
    message: string;
    param: any;
    title: string;
    complement: string;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            message: string;
            complement: string;
            param: any;
            title: string;
            value: any;
        },
        private router: Router
    ) {
        this.message = data.message;
        this.param = data.param;
        this.title = data.title;
        this.complement = data.complement;
    }

    reload() {
      if(this.message == 'authentication.access-denied'){
        this.router.navigate(['/login']);
      }
      if(this.message == 'order-details.order-not-found'){
        this.router.navigate(['/orders-dashboard']);
      }
    }
}
